const formatDate = (value) => {
  if (!value) return '';
  const date = new Date(value);
  return date.toLocaleDateString(undefined, { year: 'numeric', month: 'short', day: 'numeric' });
};

const getPORequestColumns = (
  userMap,
  actionRenderer,
  vendorColWidth,
  projectColWidth,
  isProcurementAdmin,
  onApproverNotesSave
) => [
  {
    headerName: 'Actions',
    field: 'actions',
    pinned: 'left',
    flex: 1,
    cellRenderer: actionRenderer,
    filter: false,
  },
  {
    headerName: 'ID',
    field: 'id',
    hide: true,
  },
  {
    headerName: 'Name',
    field: 'name',
    sortable: true,
  },
  {
    headerName: 'Request Type',
    field: 'rfqType',
    enableRowGroup: false,
    hide: true,
    sortable: true,
  },
  {
    headerName: 'Description',
    field: 'description',
    wrapText: true,
  },
  {
    headerName: 'Applied Vendor(s)',
    field: 'appliedVendors',
    enableRowGroup: true,
    wrapText: true,
    autoHeight: true,
    hide: false,
    width: vendorColWidth,
    cellStyle: { whiteSpace: 'pre-wrap' },
    valueFormatter: (params) => params.value?.map((v) => v).join('\n') || '(No Vendors)',
  },
  {
    headerName: 'Vendor Instructions',
    field: 'vendorInstructions',
    wrapText: true,
    hide: true,
  },
  {
    headerName: 'Applied Project + Subsidiary List',
    field: 'projectSubsidiaryNameList',
    wrapText: true,
    enableRowGroup: true,
    autoHeight: true,
    hide: false,
    width: projectColWidth,
    cellStyle: { whiteSpace: 'pre-wrap' },
    valueFormatter: (params) => params.value?.map((ps) => ps).join('\n') || '(No Projects / Subsidiary Pairs)',
  },
  {
    headerName: 'Delivery Location',
    field: 'deliveryLocation',
    enableRowGroup: true,
    width: 250,
  },
  {
    headerName: 'Proposal Due Date',
    field: 'proposalDueDate',
    enableRowGroup: true,
    valueFormatter: (params) => formatDate(params.value),
  },
  {
    headerName: 'Desired Delivery / Service Completion Date',
    field: 'desiredDeliveryDate',
    enableRowGroup: true,
    valueFormatter: (params) => formatDate(params.value),
  },
  {
    headerName: 'Last Modified Date',
    enableRowGroup: true,
    field: 'lastModifiedDate',
    valueFormatter: (params) => formatDate(params.value),
  },
  {
    headerName: 'Approver Notes',
    field: 'approverNotes',
    hide: false,
    wrapText: true,
    width: 400,
    editable: isProcurementAdmin,
    onCellValueChanged: (params) => {
      onApproverNotesSave(params.data.id, params.newValue, params.oldValue);
    },
  },
  {
    headerName: 'Created By',
    enableRowGroup: true,
    field: 'createdBy',
    valueFormatter: (params) => userMap?.get?.(params.value) || 'Unknown User',
  },
  {
    headerName: 'Last Modified By',
    enableRowGroup: true,
    field: 'lastModifiedBy',
    valueFormatter: (params) => userMap?.get?.(params.value) || 'Unknown User',
  },
];

export default getPORequestColumns;
